import React from 'react';
import { CheckCircle2, ShieldCheck, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { useCountdown } from './Countdown';
export function Pricing() {
  const {
    minutes,
    seconds
  } = useCountdown(3, 58); // Starts at 03:58 as requested
  return <section id="oferta" className="w-full bg-navy py-12 sm:py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden scroll-mt-16" data-id="element-118">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-119">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" data-id="element-120"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" data-id="element-121"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-122">
        <div className="text-center mb-6 sm:mb-12" data-id="element-123">
          <h2 className="text-2xl sm:text-5xl font-heading font-black text-white mb-2 sm:mb-4" data-id="element-124">
            Todo lo que incluye tu compra
          </h2>
          <p className="text-gray-300 text-sm sm:text-lg" data-id="element-125">
            Acceso inmediato a todo esto por un único pago.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] p-5 sm:p-10 shadow-2xl" data-id="element-126">
          <div className="space-y-1.5 sm:space-y-4 mb-5 sm:mb-10" data-id="element-127">
            <div className="flex items-center justify-between gap-4 py-2 sm:py-3 border-b border-gray-100" data-id="element-128">
              <div className="flex items-center gap-2.5 sm:gap-3" data-id="element-129">
                <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-navy shrink-0" data-id="element-130" />
                <span className="font-bold text-navy text-sm sm:text-base" data-id="element-131">
                  PROFE PACK (Biblioteca 6 Volúmenes)
                </span>
              </div>
              <span className="font-bold text-navy text-sm sm:text-base" data-id="element-132">
                47 USD
              </span>
            </div>

            {['Bono #1 · 50 Calentamientos', 'Bono #2 · Juegos de Cierre', 'Bono #3 · Clases Especiales', 'Bono #4 · Kit de Consignas', 'Bono #5 · Plantillas Semanales'].map((bono, idx) => <div key={idx} className="flex items-center justify-between gap-4 py-2 sm:py-3 border-b border-gray-100" data-id="element-133">
                <div className="flex items-center gap-2.5 sm:gap-3" data-id="element-134">
                  <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-success shrink-0" data-id="element-135" />
                  <span className="font-medium text-gray-700 text-sm sm:text-base" data-id="element-136">
                    {bono}
                  </span>
                </div>
                <span className="font-bold text-success text-sm sm:text-base" data-id="element-137">
                  GRATIS
                </span>
              </div>)}

            <div className="flex items-center justify-between gap-4 py-2 sm:py-3" data-id="element-138">
              <div className="flex items-center gap-2.5 sm:gap-3" data-id="element-139">
                <ShieldCheck className="w-4 h-4 sm:w-5 sm:h-5 text-primary shrink-0" data-id="element-140" />
                <span className="font-bold text-navy text-sm sm:text-base" data-id="element-141">
                  Garantía de 7 días
                </span>
              </div>
              <span className="font-bold text-primary text-sm sm:text-base" data-id="element-142">
                INCLUIDA
              </span>
            </div>
          </div>

          <div className="text-center mb-5 sm:mb-8" data-id="element-143">
            <p className="text-gray-500 text-sm sm:text-base mb-1 sm:mb-2" data-id="element-144">
              Valor total regular <span className="line-through" data-id="element-145">232 USD</span>
            </p>
            <div className="inline-block bg-primary/10 text-primary font-bold px-4 py-1 rounded-full text-xs sm:text-sm mb-2 sm:mb-4 uppercase tracking-wider" data-id="element-146">
              Oferta de hoy
            </div>
            <div className="text-4xl sm:text-6xl font-heading font-black text-navy mb-1 sm:mb-2" data-id="element-147">
              17 USD
            </div>
            <p className="text-gray-600 font-medium text-sm sm:text-base" data-id="element-148">
              Precio único · Acceso de por vida
            </p>
            <p className="text-xs sm:text-sm text-gray-400 mt-1" data-id="element-149">
              Pagas el equivalente en la moneda de tu país.
            </p>
          </div>

          <div className="bg-cream-dark/50 rounded-xl p-2.5 sm:p-3 mb-4 sm:mb-6 text-center border border-gray-100" data-id="element-150">
            <p className="text-[11px] sm:text-xs font-bold text-navy uppercase tracking-wider mb-1.5" data-id="element-151">
              Esta oferta expira en
            </p>
            <div className="flex items-center justify-center gap-2 font-heading font-black" data-id="element-152">
              <div className="flex flex-col items-center" data-id="element-153">
                <div className="bg-navy text-white text-base sm:text-xl rounded-md w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center shadow-inner" data-id="element-154">
                  {minutes}
                </div>
                <span className="text-[8px] sm:text-[9px] uppercase tracking-widest text-gray-500 mt-1 font-sans font-bold" data-id="element-155">
                  MIN
                </span>
              </div>
              <div className="text-base sm:text-xl text-navy pb-3 sm:pb-4" data-id="element-156">
                :
              </div>
              <div className="flex flex-col items-center" data-id="element-157">
                <div className="bg-navy text-white text-base sm:text-xl rounded-md w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center shadow-inner" data-id="element-158">
                  {seconds}
                </div>
                <span className="text-[8px] sm:text-[9px] uppercase tracking-widest text-gray-500 mt-1 font-sans font-bold" data-id="element-159">
                  SEG
                </span>
              </div>
            </div>
          </div>

          <a href="https://kit-gimnasia-artistica-infantil.impultienda.ar/checkout" className="w-full bg-primary hover:bg-primary-hover text-white font-heading font-black text-lg sm:text-2xl py-4 sm:py-5 rounded-xl shadow-[0_8px_24px_0_rgba(241,90,41,0.4)] transition-all transform hover:-translate-y-1 mb-3 sm:mb-4 flex flex-col items-center justify-center gap-0.5 sm:gap-1" data-id="element-160">
            <span data-id="element-161">Finalizar compra — 17 USD</span>
            <span className="text-xs sm:text-sm font-sans font-medium text-white/90" data-id="element-162">
              Ahorras 215 USD
            </span>
          </a>

          <div className="flex items-center justify-center gap-3 sm:gap-4 text-[11px] sm:text-xs font-medium text-gray-500" data-id="element-163">
            <span className="flex items-center gap-1" data-id="element-164">
              <ShieldCheck className="w-4 h-4" data-id="element-165" /> Garantía de devolución de 7
              días
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-166">•</span>
            <span className="flex items-center gap-1" data-id="element-167">
              <Lock className="w-4 h-4" data-id="element-168" /> Compra 100% segura
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}